import CryptoJS from 'crypto-js';

const apiKey = 'app-key-buka-template';
const apiSecret = 'app-secret-DF0090F334BB98897648185152A0C74C';

export class ApiAuth {
  static generateSignature(method, path, body, timestamp) {
    const signatureString = `${method}\n${path}\n${timestamp}\n${body}`;
    const signature = CryptoJS.HmacSHA256(signatureString, apiSecret).toString(CryptoJS.enc.Hex);
    return signature;
  }

  static getAuthHeaders(method, url, body = '') {
    const timestamp = Date.now().toString();
    const urlObj = new URL(url);
    const path = urlObj.pathname + urlObj.search;
    const signature = this.generateSignature(method, path, body, timestamp);

    return {
      'X-API-Key': apiKey,
      'X-Signature': signature,
      'X-Timestamp': timestamp,
    };
  }
}

export const API_KEY = apiKey;
export const API_SECRET = apiSecret;